import { provideZoneChangeDetection } from "@angular/core";
import "./app/global";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app";
import { getApplicationConfig } from "./app/app.config";


getApplicationConfig().then((config) => {
    if (config == null)
        return;

    bootstrapApplication(AppComponent, {...config, providers: [provideZoneChangeDetection(), ...config.providers]})
        .catch((err) => console.error(err))
});
